import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";

/**
 * Edit the customer name and email on an existing invoice.
 */
const CustomerDialog = ({
  open,
  loading,
  invoice,
  name,
  email,
  onNameChange,
  onEmailChange,
  onSave,
  onClose,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>Customer Details</DialogTitle>

    <DialogContent dividers>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: 250 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container spacing={2} style={{ marginBottom: 20 }}>
            <Grid item xs={12} sm={3}>
              <Typography variant="caption" color="textSecondary">
                Invoice
              </Typography>

              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {invoice?.invoice_no || "---"}
              </Typography>
            </Grid>
          </Grid>

          <Divider />

          <Box mt={3}>
            <Typography
              variant="subtitle2"
              style={{ fontWeight: 600, marginBottom: 15 }}
            >
              Update Details
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Name"
                  value={name}
                  onChange={(e) => onNameChange(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Email"
                  value={email}
                  onChange={(e) => onEmailChange(e.target.value)}
                />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose}>Close</Button>

      <Button variant="contained" color="primary" onClick={onSave}>
        Update
      </Button>
    </DialogActions>
  </Dialog>
);

CustomerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  invoice: PropTypes.object,
  name: PropTypes.string,
  email: PropTypes.string,
  onNameChange: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

CustomerDialog.defaultProps = {
  loading: false,
  name: "",
  email: "",
};

export default CustomerDialog;
